import { currentTimestampSeconds, numberOfItemsInShoppingCart } from './utils';

export default {
  isVisible(state, getters, rootState) {
    const isOrderable =
      rootState.isAuthenticated && state.baseShapeData.orderable;
    return {
      deliveryDate: isOrderable,
      discount:
        isOrderable &&
        state.baseShapePriceData.products?.some(x => x.discount > 0),
      priceEach: isOrderable,
      quantity: isOrderable,
      safetyType: state.baseShapeData.products?.some(
        x =>
          x.safetyType !== undefined &&
          x.safetyType !== null &&
          x.safetyType !== ''
      ),
      segment: state.baseShapeData.products?.some(
        x =>
          x.segmentationImageUrl !== undefined &&
          x.segmentationImageUrl !== null &&
          x.segmentationImageUrl !== ''
      ),
      subtotal: isOrderable,
      weight: state.baseShapeData.products?.some(
        x => x.weight !== undefined && x.weight !== null && x.weight !== ''
      )
    };
  },
  numberOfItemsInShoppingCart(state) {
    const count = numberOfItemsInShoppingCart(state.shoppingCart.baseShapes);
    if (!count) return state.numberOfItemsInShoppingCart;
    return count;
  },
  productsToAddToShoppingCart(state) {
    if (!state.baseShapePriceData.products) return [];
    return state.baseShapePriceData.products.filter(x => x.quantity > 0);
  },
  productsToAddToShoppingCartPayload(state, getters) {
    if (!state.baseShapePriceData.products) return [];
    return getters.productsToAddToShoppingCart.map(x => ({
      product_code: x.productCode,
      product_url: x.productUrl,
      quantity: x.quantity
    }));
  },
  shoppingCartExpired(state) {
    if (!state.shoppingCartLastRefreshedTimestamp) return true;
    return (
      currentTimestampSeconds - state.shoppingCartLastRefreshedTimestamp > 600 // 10 mins
    );
  }
};
